import SelectItem from './SelectItem';
import SelectMain from './Select';
// const SelectTemp: any = SelectMain;
const SelectTemp = SelectMain;
SelectTemp.Item = SelectItem;
const Select = SelectTemp;
export default Select;
//# sourceMappingURL=index.js.map